/**
 * Composer Computer-button affordance (founder 08-12): the button must
 * signal a live browser behind a closed panel and open onto the surface
 * the task actually uses. Pure — MessageInput subscribes to the primitive
 * inputs and derives (same pattern as computeStripOrder).
 */
import type { AgentSurface } from "@/stores/computerStore";

export type ComposerViewState =
  | "hidden"
  | "waking"
  | "live"
  | "suspended"
  | "error"
  | null;

export interface ComposerBrowserAffordance {
  /** Small purple dot on the button: browsing is happening, panel closed. */
  showDot: boolean;
  /** Which tab a manual open should land on. */
  openTab: "files" | "browser";
}

export function composerBrowserAffordance(input: {
  panelOpen: boolean;
  viewState: ComposerViewState;
  /** Only 'browser' reads as browser context; the desktop-only surfaces
   *  ('terminal' | 'files') fall through to Files, same as 'app'. */
  agentContext: AgentSurface | null;
  hasStoredFrame: boolean;
}): ComposerBrowserAffordance {
  const busy = input.viewState === "live" || input.viewState === "waking";
  const browserContext =
    input.agentContext === "browser" ||
    input.hasStoredFrame ||
    busy ||
    input.viewState === "suspended" ||
    input.viewState === "error";
  return {
    showDot: busy && !input.panelOpen,
    openTab: browserContext ? "browser" : "files",
  };
}
